import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import {
  ELEMENT_QUESTION_LIST,
  ELEMENT_QUESTION_LIST_ITEM,
  QuestionListPluginOptions,
} from './QuestionListPlugin.types';

const QuestionList = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./components/QuestionList').then((mod) => mod.QuestionList),
));
const QuestionListItem = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./components/QuestionListItem').then((mod) => mod.QuestionListItem),
));

export const QuestionListPlugin = (options: QuestionListPluginOptions = {}): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      if (element?.type === ELEMENT_QUESTION_LIST) {
        return <QuestionList {...renderProps} {...options} />;
      }
      if (element?.type === ELEMENT_QUESTION_LIST_ITEM) {
        return <QuestionListItem {...renderProps} {...options} />;
      }
      return undefined;
    },
  };
};
